import { render } from "./Pago.vue?vue&type=template&id=6cc3ed99&scoped=true&bindings={\"breadcrumbA\":\"data\",\"breadcrumbB\":\"data\",\"descripcion\":\"data\",\"triggers\":\"data\",\"semanas\":\"data\",\"obtenerPersonal\":\"options\"}"
import script from "./Pago.vue?vue&type=script&lang=js"
export * from "./Pago.vue?vue&type=script&lang=js"

import "./Pago.vue?vue&type=style&index=0&id=6cc3ed99&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-6cc3ed99"

export default script